export let data =
    {
        "result": true,
        "message": "SUCCESS",
        "data": [
            {
                "id": 301,
                "questionType": "STAR",
                "text": "Uçak içi internet hizmetimizi nasıl buldunuz?",
                "label": null,
                "flightType": "INT",
                "flightRange": "LONG",
                "locale": "tr"
            },
            {
                "id": 341,
                "questionType": "SELECT",
                "text": "İnternete bağlanma sürecini nasıl değerlendirirsiniz?",
                "label": null,
                "flightType": "ALL",
                "flightRange": "ALL",
                "locale": "tr",
                "options": [
                    {
                        "id": 43,
                        "text": "Kötü"
                    },
                    {
                        "id": 121,
                        "text": "İyi"
                    }
                ]
            },
            {
                "id": 194,
                "questionType": "SELECT",
                "text": "Uçak içi internet hizmetimize kayıt olma ve bağlanma sürecinizi nasıl değerlendirirsiniz?",
                "label": null,
                "flightType": "INT",
                "flightRange": "LONG",
                "locale": "tr",
                "options": [
                    {
                        "id": 2,
                        "text": "Çok Kolaydı"
                    },
                    {
                        "id": 21,
                        "text": "Kolaydı"
                    },
                    {
                        "id": 22,
                        "text": "Ne Kolay Ne Zordu"
                    },
                    {
                        "id": 4,
                        "text": "Zordu"
                    },
                    {
                        "id": 10,
                        "text": "Çok Zordu"
                    }
                ]
            },
            {
                "id": 195,
                "questionType": "TEXT",
                "text": "Uçak içi internet hizmetimizle ilgili yorum veya önerilerinizi bize iletebilirsiniz.",
                "label": "Yorum/Öneriniz",
                "flightType": "INT",
                "flightRange": "LONG",
                "locale": "tr",
                "options": []
            }
        ],
        "jwt": null,
        "flightNumber": null
    };